const CHa_En=[
    {CHA:"可免费下载全文",ENG:'Download fulltext free'},
    {CHA:"只有订户可下载",ENG:"Download only by register"},
    {CHA:"登陆后可免费下载全文",ENG:"Download fulltext free after login"},
    {CHA:"没有找到文件",ENG:"File not exist"},
    {CHA:"登录后下载",ENG:"Download fulltext free after login"},
    {CHA:"验证码验证失败",ENG:"Verification code error"},
    {CHA:"注册失败",ENG:"registration failed"},
    {CHA:"参数异常",ENG:"Parameter abnormal"},
    {CHA:"验证码失效",ENG:"Verification code is invalid"},
    {CHA:"没有找到对应的验证码数据",ENG:"No corresponding verification code data found"},
    {CHA:"验证码相关参数异常",ENG:"Verification code related parameters are abnormal"},
    {CHA:"由于参数异常，用户信息转化失败",ENG:"User information conversion failed due to abnormal parameters"},
    {CHA:"验证码验证失败",ENG:"Verification code error"},
    {CHA:"用户名或密码错误",ENG:"wrong user name or password"},
    {CHA:"账号被禁用",ENG:"Account is disabled"},
    {CHA:"登录失败，该用户不具备相应角色。",ENG:"Login failed, the user does not have the corresponding role."},
    {CHA:"修改成功",ENG:"Successfully modified"},
    {CHA:"参数异常或未找到相关用户",ENG:"Abnormal parameter or related user not found"},
    {CHA:"评论的类型不正确",ENG:"Incorrect comment type"},
    {CHA:"找不到评论的文章",ENG:"Can't find commented article"},
    {CHA:"评论内容不能为空",ENG:"Comment content cannot be empty"},
    {CHA:"评论人不为空",ENG:"Commenter is not empty"},
    {CHA:"评论成功",ENG:"Comment successful"},
    {CHA:"评论失败",ENG:"Comment failed"},
    {CHA:"参数异常",ENG:"Parameter abnormal"},
    {CHA:"审稿已完成，无需操作",ENG:"The review has been completed, no action is required"},
    {CHA:"登录成功",ENG:"login successful"},
    {CHA:"未找到审稿记录",ENG:"No review records found"},
    {CHA:"登录验证已失效",ENG:"Login verification has expired"},
]
export default {
    CH_EN(text){
        var en=""
        
        CHa_En.every(x=>{
            if(x.CHA==text){
                en=x.ENG
                return false
            }else if(text.indexOf("该帐号已经被锁定")>-1){
                en="The account has been locked, please try again in half an hour"
                return false
            }else if(text.indexOf("用户名或密码错误，您还有")>-1){
                let num=0
                num=text.replace(/[^0-9]/ig, "")
                en = "wrong user name or password"+"You have"+" "+ num+" " +"more chances"
                return false
            }else if(text.indexOf("邮箱或密码错误，您还有")>-1){
                let num=0
                num=text.replace(/[^0-9]/ig, "")
                en = "Mail or password is incorrect"+"You have"+" "+ num+" " +"more chances"
                return false
            }else if(text.indexOf("手机号或密码错误，您还有")>-1){
                let num=0
                num=text.replace(/[^0-9]/ig, "")
                en = "Incorrect phone number or password"+"You have"+" "+ num+" " +"more chances"
                return false
            }else{
                en="Operation failed, please try again later"
                return true
            }
            
        })
        return en;
    }
}